class MessageParser {
    constructor(actionProvider) {
      this.actionProvider = actionProvider;
    }
  
    parse(message) {
      const lowerCaseMessage = message.toLowerCase();

      if (
          lowerCaseMessage.includes('hello') ||
          lowerCaseMessage.includes('hi') ||
          lowerCaseMessage.includes('hey') ||
          lowerCaseMessage.includes('salut') ||
          lowerCaseMessage.includes('yo') ||
          lowerCaseMessage.includes('bonjour')
      ){
        this.actionProvider.handleGreet();
      }
      
  
      // if (lowerCaseMessage.includes('e-Transfer?')) {
      //   this.actionProvider.WhatIseTransfer();
      // }

      // carrers
      else if (['comment puis-je postuler pour un emploi', 'carrière', 'carrières', 'poser sa candidature', 'travail', 'travaux', 'embauche'].some(el => lowerCaseMessage.includes(el)) ) {
        this.actionProvider.careers();
    }

    // contact
    else if (['contact', 'humaine', 'humain', 'phone', 'téléphone', 'vous contacter', 'nous contacter', 'agente', 'agent'].some(el => lowerCaseMessage.includes(el)) ) {
      this.actionProvider.contactUs();
  }

      // Interac e-Transfer
        else if (['qu\'est-ce que le transfert électronique', 'qu\'est-ce que le virement électronique', 'how etransfer'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.WhatIseTransfer();
      }

      else if (['what is etransfer', 'what is e-transfer', 'how etransfer', 'how e-transfer', 'Qu’est-ce que le service Virement Interac?', 'qu’est-ce que le service virement?'].some(el => lowerCaseMessage.includes(el)) ) {
        this.actionProvider.WhatIseTransfer();
    }

        else if (['where\'s my transfer', 'where\'s transfer', 'where\'s etransfer', 'where\'s my e-transfer', 'wheres my e-transfer', 'wheres my transfer', 'where my etransfer', 'where is my etransfer'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.handleEtransfer6();
        }

        else if (['how do i send money via interac e-transfer?', 'how do i send money via etransfer?', 'how do i send money via e-transfer?', 'how to send money using etransfer?', 'how to send', 'how do i send', 'sending money', 'Comment puis-je envoyer des fonds à l’aide de Virement?'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.eTransferHowToSend();
        }

        else if (['how do i cancel an interac e-transfer transaction', 'how do i cancel an etransfer transaction', 'how to cancel', 'how do i cancel', 'cancel etransfer', 'cancel e-transfer', 'Comment puis-je annuler une transaction effectuée par Virement?'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.eTransferHowToCancel();
        }
        else if (['How secure is it to send money by email or text message through Interac e-Transfer?', ' is etransfer secure', 'e-transfer secure', 'how secure is e-transfer', 'how secure is etransfer', 'Dans quelle mesure est-il sécuritaire d’envoyer de l’argent par courriel ou par message texte à l’aide de Virement?'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.HowToSecureEtransfer();
        }
        else if (['How much does it cost to send money via Interac e-Transfer', 'is etransfer free', 'how much does it cost to send', 'cost send e-transfer', 'is e-transfer free', 'Combien coûte l’envoi de fonds par Virement?'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.etransferCost();
        }
        else if (['Are there limits on the amount I can send', 'etransfer limit', 'e-transfer limit', 'send limit', 'Y a-t-il des limites quant au montant qu’on peut envoyer?'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.etransferLimit();
        }
        else if (['I received an Interac e-Transfer text message, but did not opt-in to this service. How do I stop receiving them', 'stop text message', 'opt-out text message', 'J’ai reçu des messages texte de Virement Interac, mais je n’ai jamais adhéré à ce service. Comment puis-je arrêter d’en recevoir?'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.etransferStopTxt();
        }
        else if (['Can I accept an Interac e-Transfer without a Canadian bank account', 'etransfer bank account', 'e-transfer bank account', 'accept Canadian', 'Puis-je accepter un Virement sans avoir un compte bancaire canadien?'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.etransferNonCanadian();
        }
        else if (['What can I do if I received money via Interac e-Transfer, but my bank doesn’t offer the service', 'bank doesn\'t offer etransfer', 'bank doesn\'t offer e-transfer', 'offer etransfer', 'Que puis-je faire si j’ai reçu de l’argent par Virement alors que ma banque n’offre pas le service?'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.etransferNoBank();
        }

        //
        else if (['What is Autodeposit', 'what is autodeposit', 'autodeposit'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.whatisAutodeposit();
        }

        // Request Money
        else if (['What is Interac e-Transfer Request Money', 'what is request moeney', 'what is request money'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.requestMoney();
        }

        else if (['What if I don’t know the answer to the security question or I use the wrong answer multiple times', 'security question', 'wrong security answer'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.etransferSecurityQA();
        }
        // Interac Flash/Debit
        else if (['How do Interac Debit and Interac Flash transactions work', 'debit transaction', 'debit work', 'flash work', 'flash transaction'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.DebitWorks();
        }
        else if (['What safeguards are in place with Interac Debit and Interac Flash to protect me against fraudulent transactions', 'debit security', 'debit safe', 'flash safe'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.DebitSecurity();
        }
        //Apple Pay
        else if (['What is Interac Debit on Apple Pay', 'debit apple pay'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.ApplePayDebit();
        }
        else if (['What is Apple Pay'].some(el => lowerCaseMessage.includes(el)) ) {
          this.actionProvider.ApplePay();
        }
        else {
          this.actionProvider.tryAgain();
        }
      }
  }
  
  export default MessageParser;